<div class="dialog-wrapper compatibility-notice">
    <div class="header">
        <img src="assets/svg/reusable-svg/warning.svg" alt="warning-icon" />
        <p>{{ 'authentication.compatibilityNotice.title' | translate }}</p>
    </div>
    <div class="notice-text">
        <ng-container *ngIf="data.showBrowserWarning">
            <p class="warning-title">
                {{ 'authentication.compatibilityNotice.browser.title' | translate }}
            </p>
            <p class="warning-description">
                {{
                    'authentication.compatibilityNotice.browser.description'
                        | translate
                }}
            </p>
        </ng-container>
        <ng-container *ngIf="data.showResolutionWarning">
            <p class="warning-title">
                {{
                    'authentication.compatibilityNotice.resolution.title'
                        | translate
                }}
            </p>
            <p class="warning-description">
                {{
                    'authentication.compatibilityNotice.resolution.description'
                        | translate
                }}
            </p>
        </ng-container>
    </div>
    <div class="action-buttons">
        <div class="button-wrapper-tryb-button">
            <button
                class="button-tryb-button standard-tryb-button"
                type="button"
                (click)="onClose()"
            >
                {{ 'authentication.compatibilityNotice.actions.ok' | translate }}
            </button>
        </div>
    </div>
</div>
